export default {
  inject: ['rootMenu'],
  computed: {
    parentMenu() {
      let parent = this.$parent
      if (
        parent &&
        ['TMenu', 'TSubmenu'].indexOf(parent.$options.name) === -1
      ) {
        parent = parent.$parent
      }
      if (parent.$options.name === 'TCollapseTransition') {
        parent = parent.$parent
      }
      return parent
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/menu/menu-mixin.js